var React = require('react');

function ArrowRightIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.6289 21L1.52045e-07 18.3391L7.7422 10.4972L8.37364e-07 2.66086L2.6289 -4.53335e-07L13 10.4972L2.6289 21Z","fill":"white"}));
}

ArrowRightIcon.defaultProps = {"width":"13","height":"21","viewBox":"0 0 13 21","fill":"none"};

module.exports = ArrowRightIcon;

ArrowRightIcon.default = ArrowRightIcon;
